import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const ITEMS = [
  { key: "leads_total", label: "Leads uniques" },
  { key: "leads_with_email", label: "Avec e-mail valide" },
  { key: "leads_with_leader", label: "Dirigeant identifié" },
  { key: "leads_do_not_call", label: "Refus démarchage", danger: true },
];

export const OverviewStats = () => {
  const { data } = useQuery({ queryKey: ["stats"], queryFn: () => api.get("/stats").then((r) => r.data), refetchInterval: 5000 });

  return (
    <div data-testid="overview-stats" className="fade-up grid h-full grid-cols-2 overflow-hidden rounded-lg border border-border bg-white shadow-sm" style={{ animationDelay: "80ms" }}>
      {ITEMS.map((item, i) => (
        <div key={item.key} className={`flex flex-col justify-between p-6 ${i % 2 === 0 ? "border-r" : ""} ${i < 2 ? "border-b" : ""} border-border`}>
          <div className="eyebrow">{item.label}</div>
          <div data-testid={`stat-${item.key}`} className={`mt-6 font-display text-4xl font-black tracking-tight ${item.danger ? "text-[#FF3B30]" : "text-zinc-950"}`}>
            {data ? data[item.key].toLocaleString("fr-CH") : "—"}
          </div>
        </div>
      ))}
      <div className="col-span-2 border-t border-border bg-zinc-50 px-6 py-4 text-xs text-muted-foreground">
        <span className="font-semibold text-zinc-700">{data?.jobs_active ?? 0}</span> recherche(s) active(s) ·{" "}
        {Object.entries(data?.by_source || {}).map(([k, v]) => `${k}: ${v}`).join(" · ") || "aucune donnée"}
      </div>
    </div>
  );
};
